import bgSample from '@/static/assets/generic_products/bg-sample.svg';
import type { GenericProductsProps } from '..';

export const GENERIC_PRODUCTS: GenericProductsProps = {
  title: 'Some sample title',
  subtitle: 'Some subtitle here for a nicer storybook',
  bgImage: bgSample,
  backdrop: {
    show: true,
    bgColor: '#f7f7f7',
    height: 210,
    position: 'bottom',
  },
  productLogo: {
    alt: 'Some alt text',
    height: 100,
    img: 'https://via.placeholder.com/100x100',
    width: 100,
  },
};
